module.exports = "<template> <div class=tyl-list role=list part=root> <slot></slot> </div> </template>";